
import { Component, HostListener, OnInit, inject } from '@angular/core';
import { GeneralService } from '@mpt-fo/common/core/services/general.service';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
	selector: 'app-accounts-closed-modal',
	templateUrl: './accounts-closed-modal.component.html',
	styleUrls: ['./accounts-closed-modal.component.scss']
})
export class AccountsClosedModalComponent implements OnInit {
	data: any;
	isMobile: boolean;
	breakPoint = 992;
	isBlock: boolean;
	runningModal: NzModalRef;
	loading = false;
	readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

	constructor(
		private modal: NzModalRef,
		private generalService: GeneralService,
	) { }

	ngOnInit(): void {
		this.setMobile(window.innerWidth);
        this.modal.componentInstance = { ...this.modal.componentInstance, ...this.nzModalData };
		this.data = this.modal.componentInstance.data;
	}

	@HostListener('window:resize', ['$event'])
	onResize(_event): void {
		this.setMobile(window.innerWidth);
	}

	setMobile(browserWidth: number) {
		this.isMobile = browserWidth <= this.breakPoint;
		if (browserWidth <= 768) {
			this.isBlock = true;
		}
	}

	logout() {
		this.modal.close();
		this.generalService.logout();
	}
}
